import { atom } from 'recoil'
import { StoreStateName } from '../storeStateName'
import { ChannelResponse } from '../../types/entities'

export const channelState = atom<ChannelResponse>({
  key: StoreStateName.CHANNEL,
  default: undefined
})
